import { inject } from '@angular/core';
import { Route, Router, UrlSegment } from '@angular/router';
import { USER } from '@tokens/user.token';
import { UserPermissions } from '@type/user.type';

export const canViewByPermission =
  (key: keyof UserPermissions, redirect: string[]) => (route: Route, segments: UrlSegment[]) =>
    inject(USER)()[key] ? inject(Router).createUrlTree(redirect) : true;
